import type { AlignerFieldToggles } from './types';

const DEFAULT_ALIGNER_FIELDS: AlignerFieldToggles = {
    numberOfAligners: true,
    nextAppointment: true,
    dmScanFrequency: true,
    alignerChangeFrequency: true,
    alignerWear: true
};

const ALIGNER_WEAR_OPTIONS: readonly string[] = [
    'Nightly',
    'After School/Eve/Night',
    'Full Time',
    '14-16 hours'
];

function isValidAlignerFieldToggles(value: unknown): value is AlignerFieldToggles {
    if (!value || typeof value !== 'object') return false;
    const obj = value as Record<string, unknown>;
    return (
        typeof obj.numberOfAligners === 'boolean' &&
        typeof obj.nextAppointment === 'boolean' &&
        typeof obj.dmScanFrequency === 'boolean' &&
        typeof obj.alignerChangeFrequency === 'boolean' &&
        typeof obj.alignerWear === 'boolean'
    );
}

function deriveAlignerFields(
    rawAlignerFields: unknown,
    fallbackEnabled: boolean
): AlignerFieldToggles {
    if (isValidAlignerFieldToggles(rawAlignerFields)) {
        return rawAlignerFields;
    }
    return {
        numberOfAligners: fallbackEnabled,
        nextAppointment: fallbackEnabled,
        dmScanFrequency: fallbackEnabled,
        alignerChangeFrequency: fallbackEnabled,
        alignerWear: fallbackEnabled
    };
}

function anyAlignerFieldEnabled(f: AlignerFieldToggles): boolean {
    return (
        f.numberOfAligners ||
        f.nextAppointment ||
        f.dmScanFrequency ||
        f.alignerChangeFrequency ||
        f.alignerWear
    );
}

function showAlignerWear(f: AlignerFieldToggles): boolean {
    return f.numberOfAligners || f.nextAppointment;
}

export {
    ALIGNER_WEAR_OPTIONS,
    DEFAULT_ALIGNER_FIELDS,
    deriveAlignerFields,
    anyAlignerFieldEnabled,
    showAlignerWear
};
